import type { WeekDayNumber } from '@@partner:types:app'

import React, { useState } from 'react'
import { Button, SelectPicker } from 'rsuite'
import { WEEK_DAYS } from './SlotTableState'

interface SlotTableCopierProps {
  onCopy: (day: WeekDayNumber) => void
}

export default function SlotTableCopier ({ onCopy }: SlotTableCopierProps) {
  const [ day, setDay ] = useState<WeekDayNumber>(1)
  return (
    <div className="flex align-middle my-2">
      <Button
        size="xs"
        appearance="primary"
        color="violet"
        onClick={() => onCopy(day)}
      >
        Скопировать из
      </Button>
      <SelectPicker
        size="xs"
        cleanable={false}
        searchable={false}
        value={day}
        onSelect={(day) => setDay(day)}
        data={WEEK_DAYS}
      ></SelectPicker>
    </div>
  )
}
